// src/api/apiService.ts
import { supabase as baseSupabase, supabaseService } from '../services/SupabaseClient';
import { recipeService } from '../services/RecipeService';
import { tagService } from '../services/TagService';
import { authorService } from '../services/AuthorService';
import { commentService } from '../services/CommentService';
import { inAppNotificationService } from '../services/InAppNotificationService';
import { storageService } from '../services/StorageService';
import { favoriteService } from '../services/FavoriteService';
import { recipeRealizationService } from '../services/RecipeRealizationService';
import { createApiService, createApiServiceModules } from './createApiService';
import { ApiServiceContract, ApiServiceModules } from './apiService.contract';

// Export base supabase client for backward compatibility
export const supabase = baseSupabase;

const apiDependencies = {
  supabaseService,
  authorService,
  recipeService,
  favoriteService,
  tagService,
  commentService,
  recipeRealizationService,
  inAppNotificationService,
  storageService,
};

export const apiModules: ApiServiceModules = createApiServiceModules(apiDependencies);

const apiService: ApiServiceContract = createApiService(apiDependencies);

export default apiService;
